module.exports = "<h2>Page not found</h2>\r\n\r\n<p>The page you were attempting to access was not found.</p>";


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found.component.html
// module id = 483
// module chunks = 0